export default {
	namespaced: true,
	state: {
		timeTrackHistory: [],
	},
	getters: {},
	mutations: {
		setTimeTrackHistory: (state, payload) => {
			state.timeTrackHistory = payload;
		},
		addNewHistoryItem: (state, payload) => {
			state.timeTrackHistory.push(payload);
		},
		clearTimeTrackHistory: (state) => {
			state.timeTrackHistory = null;
		},
	},
	actions: {
		setDefaultTimeTrack: ({ commit }) => {
			commit('clearTimeTrackHistory');
		},
	},
};
